// HierarchyInitializationContext.tsx
import type { ReactNode } from "react";
import { createContext, useContext, useMemo, useRef } from "react";

interface HierarchyInitializationContextType {
    isInitialized: React.MutableRefObject<boolean>;
    setInitialized: () => void;
}

const HierarchyInitializationContext = createContext<HierarchyInitializationContextType | null>(null);

export const HierarchyInitializationProvider = ({ children }: { children: ReactNode }) => {
    const isInitialized = useRef(false);
    const setInitialized = () => {
        isInitialized.current = true;
    };
    const providerValue = useMemo(() => ({ isInitialized, setInitialized }), []);

    return (
        <HierarchyInitializationContext.Provider value={providerValue}>
            {children}
        </HierarchyInitializationContext.Provider>
    );
};

export const useHierarchyInitialization = () => {
    const context = useContext(HierarchyInitializationContext);
    if (!context) throw new Error("useHierarchyInitialization must be used within HierarchyInitializationProvider");
    return context;
};
